import { useState } from "react";

import CreditPaymentImporterConfirmation from "../CreditPaymentImporterConfirmation/CreditPaymentImporterConfirmation";
import FileUploadImporterCredit from "../FileUploadImporterCredit/FileUploadImporterCredit";
import Modal from "../Modal/Modal";

const STATES = {
  CONFIRM_IMPORTER: 0,
  UPLOAD_FILE: 1,
};

function CreditPaymentImporterModal(props) {
  const {
    toggleModal,
    invoices,
    payerItems,
    payerRucOption,
    closeModal,
    dateUrlQuotationQuoted,
    quotation_ids,
    clearShoppingCar,
  } = props;
  const filterPayerItemAgent = payerItems.filter(
    (payerItem) => payerItem.payerRucOption
  )[0];
  const [importerState, updateImporter] = useState(STATES.CONFIRM_IMPORTER);
  return (
    <Modal onOutsideClick={() => toggleModal()}>
      {importerState === STATES.CONFIRM_IMPORTER ? (
        <CreditPaymentImporterConfirmation
          onConfirm={() => updateImporter(STATES.UPLOAD_FILE)}
          filterPayerItemAgent={filterPayerItemAgent}
          payerRucOption={payerRucOption}
        />
      ) : null}
      {importerState === STATES.UPLOAD_FILE ? (
        <FileUploadImporterCredit
          volanteIds={invoices.map((invoice) => invoice.volanteId)}
          filterPayerItemAgent={filterPayerItemAgent}
          toggleModal={toggleModal}
          payerRucOption={payerRucOption}
          closeModal={closeModal}
          dateUrlQuotationQuoted={dateUrlQuotationQuoted}
          quotation_ids={quotation_ids}
          clearShoppingCar={clearShoppingCar}
        />
      ) : null}
    </Modal>
  );
}

export default CreditPaymentImporterModal;
